import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-check-in-model-pop-up',
  templateUrl: './check-in-model-pop-up.component.html',
  styleUrls: ['./check-in-model-pop-up.component.scss']
})
export class CheckInModelPopUpComponent implements OnInit {
  arrivalDate: string;
  constructor(public datepipe:DatePipe,public dialogRef: MatDialogRef<CheckInModelPopUpComponent>,
    public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.arrivalDate = this.datepipe.transform(new Date(this.data.checkInDate),'dd/MM/YYYY');
  }
  public closePopup() {
    this.dialogRef.close({ data: 1 });
  }
}
